import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import { PackingForm } from '../../../app/models/PackingForm';
import usePackingFormService from '../../../app/services/hooks/usePackingFormService';
import PackingForm_FormContainer from './PackingForm_FormContainer';

interface Props {
    packingFormId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const PackingFormEdit = ({ packingFormId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const {
        fetchingEditPackingForm,
        editPackingForm,
        fetchingUpdatePackingForm,
        updatePackingForm
    } = usePackingFormService();

    const [packingForm, setPackingForm] = useState<PackingForm>({ name: '' });
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando forma de empaque...');
        editPackingForm(packingFormId, {
            onSuccess: (response: ServiceResponse) => {
                setPackingForm(response.data.packing_form);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando forma de empaque...');
        updatePackingForm(packingFormId, packingForm, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditPackingForm ? (
        <LazyLoading height="300" />
    ) : (
        <PackingForm_FormContainer
            fetching={fetchingUpdatePackingForm}
            action={update}
            cancel={cancel}
            packingForm={packingForm}
            setPackingForm={setPackingForm}
            errorFields={errorFields}
        />
    );
};

export default PackingFormEdit;
